import { useEffect, useRef } from 'react';

import { useEventHandler } from '../../../../hooks/useEventHandler';
import { usePrivateWebsocketService } from '../usePrivateWebsocketService';

export const useSubscribeToPrivateWebsocketEvent = <T = unknown>(
  channelName: string | undefined,
  eventName: string,
  callback: (data: T) => void,
) => {
  const privateWebsocketService = usePrivateWebsocketService();
  const unsubscribeRef = useRef<() => void | undefined>(undefined);
  const handlePrivateWebsocketEvent = useEventHandler(callback);

  useEffect(() => {
    if (channelName) {
      unsubscribeRef.current = privateWebsocketService.subscribeToEvent<T>(
        channelName,
        eventName,
        handlePrivateWebsocketEvent,
      );
    }
    return unsubscribeRef.current;
  }, [channelName, eventName, handlePrivateWebsocketEvent]);
};
